import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import VacancyTestCampaignEditor from "../components/vacancies/VacancyTestCampaignEditor";
import { getVacancyById } from "../services/vacancyApi";

export default function VacancyTestsPage() {
    const { vacancyId: vacancyIdParam } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const vacancyId = useMemo(() => Number(vacancyIdParam), [vacancyIdParam]);
    const initialName = String(location.state?.vacancyName || "").trim();
    const [vacancyName, setVacancyName] = useState(initialName);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    useEffect(() => {
        let active = true;
        if (!Number.isInteger(vacancyId) || vacancyId <= 0) {
            setError("Некорректный идентификатор вакансии.");
            setLoading(false);
            return () => {
                active = false;
            };
        }

        setLoading(true);
        setError("");
        getVacancyById(vacancyId)
            .then((vacancy) => {
                if (!active) return;
                setVacancyName(String(vacancy?.name || initialName || `Вакансия #${vacancyId}`));
            })
            .catch((reason) => {
                if (!active) return;
                setError(`Не удалось загрузить вакансию: ${reason?.message || reason}`);
            })
            .finally(() => {
                if (active) setLoading(false);
            });

        return () => {
            active = false;
        };
    }, [initialName, vacancyId]);

    return (
        <MainLayout className="flex h-full flex-col overflow-y-auto bg-[#f6f7f9]">
            <div className="mx-auto w-full max-w-[1320px] pb-10">
                <nav className="mb-4 flex items-center gap-2 text-sm text-slate-500" aria-label="Навигация">
                    <Link to="/vacancies" className="hover:text-slate-900 hover:underline">
                        Вакансии
                    </Link>
                    <span aria-hidden="true">/</span>
                    <span className="text-slate-700">Тестирование</span>
                </nav>

                <header className="mb-5 flex flex-wrap items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-5 shadow-sm sm:px-6">
                    <div className="min-w-0">
                        <p className="text-xs font-semibold uppercase tracking-widest text-amber-700">Вакансия · {vacancyName || "Загрузка…"}</p>
                        <h1 className="mt-1 text-2xl font-bold tracking-tight text-slate-950 sm:text-[28px]">Тесты для вакансии</h1>
                        <p className="mt-1 text-sm text-slate-600">Порядок отправки, аудитория и сообщения кандидатам.</p>
                    </div>
                    <Link
                        to="/vacancies"
                        className="inline-flex min-h-10 items-center gap-2 rounded-lg border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
                    >
                        <span aria-hidden="true">←</span>
                        К списку вакансий
                    </Link>
                </header>

                {loading ? (
                    <div className="rounded-3xl border border-slate-200 bg-white px-6 py-24 text-center text-lg text-slate-600 shadow-sm">
                        Загрузка вакансии…
                    </div>
                ) : error ? (
                    <div className="rounded-3xl border border-rose-200 bg-rose-50 px-6 py-10 text-center">
                        <h2 className="text-xl font-bold text-rose-900">Страница тестирования недоступна</h2>
                        <p className="mt-2 text-base text-rose-700" role="alert">{error}</p>
                        <Link to="/vacancies" className="mt-5 inline-flex rounded-xl bg-slate-900 px-5 py-3 text-base font-semibold text-white">
                            Вернуться к вакансиям
                        </Link>
                    </div>
                ) : (
                    <VacancyTestCampaignEditor
                        vacancyId={vacancyId}
                        vacancyName={vacancyName}
                        onClose={() => navigate("/vacancies")}
                    />
                )}
            </div>
        </MainLayout>
    );
}
